import { memo } from 'react';

import { Button } from 'design-system';
import { Cookie } from 'lucide-react';

const CookieBannerFull = ({
  handleAccept,
  handleDecline
}: {
  handleAccept: () => void;
  handleDecline: () => void;
}) => {
  return (
    <section
      aria-label='Cookie preferences'
      className='fixed right-0 bottom-0 left-0 z-[var(--z-cookie-banner)] bg-gx-tile-dark px-6 py-7 shadow-lg xl:left-[calc(50%_-_1015px)]'
    >
      <div className='mx-auto flex h-[60px] max-w-[1000px] items-center justify-between'>
        <div className='flex items-center'>
          <Cookie className='size-16 shrink-0' />
          <p className='px-6'>
            To ensure the best experience this application uses cookies as outlined in our{' '}
            <a
              className='underline underline-offset-3 hover:text-gx-highlight'
              href='https://www.general-index.com/privacy-cookies'
              rel='noreferrer'
              target='_blank'
            >
              Privacy Policy
            </a>
            . Cookies are required for the app to work correctly. Declining cookies will disable
            essential features and you won’t be able to use the app. Do you wish to decline cookies?
          </p>
        </div>
        <div className='flex shrink-0 items-center justify-end gap-2.5'>
          <Button
            className='w-[174px]'
            variant='outline'
            onClick={handleDecline}
          >
            Decline
          </Button>
          <Button
            className='w-[174px]'
            onClick={handleAccept}
          >
            <Cookie />
            Accept Cookies
          </Button>
        </div>
      </div>
    </section>
  );
};

export default memo(CookieBannerFull);
